
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/works/[id]",
      function () {
        return require("private-next-pages/works/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/works/[id]"])
      });
    }
  